//Home page view
import Barba from 'barba.js'
//Progressive from

const Single = Barba.BaseView.extend({
  namespace: 'single',
  screenWidth: window.innerWidth,
  onEnter(){
    $('.back-to-top').click(function(){
      Barba.scrollToTheTop();
      alert(hey);
    })
  },
  onEnterCompleted(){

  },

  onLeave(){
    this.destroy();
  },
  $el: null,
  _construct(){
  },
  destroy(){

  }
});
export default Single;



// WEBPACK FOOTER //
// ./source/scripts/modules/barbaviews/single.js